import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"
import GridResponse from "../GridResponse"
import OrderResultRecord from "./OrderResultModel/OrderResultRecord"

export type ServiceHistoryGridResponse = GridResponse<OrderResultRecord>

interface CurrentServiceHistoryParams {
  AccountTypeID?: number
  PersonID: number
  PoolID?: number
  PageNumber: number
  PageSize: number
}

function requestParams(options: CurrentServiceHistoryParams) {
  return JSON.stringify({
      AccountTypeID: AccountTypeID,
      PersonID: options.PersonID,
      PoolID: options.PoolID,
      PageNumber: options.PageNumber,
      PageSize: options.PageSize
  })
}

export const GetCurrentServiceHistory = (params: CurrentServiceHistoryParams) => ObservableFromFetch<ServiceHistoryGridResponse>("WorkforceTrack/GetEmployeeTestHistory", requestParams(params))
